export const DEALER_USER_ROLE: string = 'DEALER_USER_ROLE';
export const IMPLANT_ROLE: string = 'IMPLANT_ROLE';
export const BACKOFFICE_ADMINISTRATOR_ROLE: string = 'BACKOFFICE_ADMINISTRATOR_ROLE';
export const END_USER_ROLE: string = 'END_USER_ROLE';
export const BANK_ACCOUNT_ADMIN_ROLE: string = 'BANK_ACCOUNT_ADMIN_ROLE';
export const GROUP_ADMIN: string = 'GROUP_ADMIN';
export const SUPERVISOR: string = 'SUPERVISOR';
export const USER_GROUP_ADMIN: string = 'USER_GROUP_ADMIN';
export const RPA_MASTER_ROLE: string = 'RPA_MASTER_ROLE';
export const DISABLED_MENU_ROLE: string = 'DISABLED_MENU_ROLE';
export const BACKOFFICE_APPROVALS_ROLE: string = 'BACKOFFICE_APPROVALS_ROLE';

export const GROUP_ADMIN_BACKOFFICE_ADMINISTRATOR = [BACKOFFICE_ADMINISTRATOR_ROLE, GROUP_ADMIN];
export const DISABLED_MENU = [DISABLED_MENU_ROLE];
